import { Controller } from "stimulus";

export default class extends Controller {
  static targets = [
    'basicAuthContainer',
    'oauthContainer',
    'oauthStatusContainer',
    'basicAuthField',
    'oauthField'
  ];

  connect() {
    this.authMethodEl = document.querySelector('[name="integration[auth][auth_method]"]');

    if (this.authMethodEl && this.authMethodEl.value === 'oauth') {
      this.showOAuth();
    } else {
      this.showBasicAuth();
    }
  }

  showBasicAuth() {
    this.basicAuthContainerTarget.classList.remove('hidden');
    this.oauthContainerTarget.classList.add('hidden');

    if (this.hasOauthStatusContainerTarget) {
      this.oauthStatusContainerTarget.classList.add('hidden');
    };

    this.basicAuthFieldTargets.forEach(el => { el.required = true; });
    this.oauthFieldTargets.forEach(el => { el.required = false; });
  }

  showOAuth() {
    this.basicAuthContainerTarget.classList.add('hidden');
    this.oauthContainerTarget.classList.remove('hidden');

    if (this.hasOauthStatusContainerTarget) {
      this.oauthStatusContainerTarget.classList.remove('hidden');
    };

    this.basicAuthFieldTargets.forEach(el => { el.required = false; });
    this.oauthFieldTargets.forEach(el => { el.required = true; });
  }
}
